<template>
  <div class="two"> 
    <div v-for="row in rows" :key="row" class="labelbody">
      <p class="text-center">HERBARIUM OF POLAR-ALPINE BOTANICAL GARDEN (KPABG)</p>


      <div style="margin-bottom: 5px; margin-top: 5px; font-size: 15px;">
        <div class="font-weight-bold">{{row.store}}</div>
        <!-- <div v-for="srow in row.species.rows.slice(1)" :key="srow"> {{ srow.species.name }} </div> -->
        <div v-for="col in meta.columns" :key="col">
          <base-geo-cell v-if = "col.fieldname === 'species'" v-bind="{mode:'labelprint', column:col, initValue:row[col.fieldname], meta:meta, rowobject:row}" v-model="row[col.fieldname]"/>
        </div>
      </div>

      <div class="d-flex flex-wrap">
        <span><point-widget v-bind="{mode:'view'}" v-model="row.coordinates"/></span> <span v-if="row.alt">. El.: {{row.alt}} m a.s.l. </span> 
      </div>
      <div class="d-flex flex-wrap">
        <!-- <span v-if="row.reserve">{{row.reserve}}.&nbsp;</span>
        <span v-if="row.country">{{row.country}}.&nbsp;</span>
        <span v-if="row.province">{{row.province}}.&nbsp;</span> -->
        <!-- <span v-if="row.location">{{row.location}}. </span> -->
        <span v-if="row.location">
          <text-widget v-bind="{mode:'view'}" v-model="row.location" ></text-widget>  
        </span>
        
      </div>

      <div class="d-flex flex-wrap">
        Leg.:&nbsp<date-widget v-bind="{mode:'view'}" v-model="row.legdate" />&nbsp{{row.legname2}}&nbsp<br>
      </div>
      <div class="d-flex flex-wrap" v-if = "row.species.rows[0] !== undefined">
        Det.:&nbsp<date-widget v-bind="{mode:'view'}" v-model="row.species.rows[0].detdate" />&nbsp{{row.species.rows[0].detname2}}&nbsp<br>
      </div>
      <span v-if="row.legnum"> No {{row.legnum}} </span> <span v-if="row.localcollnumber">{{row.mainstorage.name}}-{{row.localcollnumber}}</span>
      <!-- <div class="text-right">LID: {{row.linkid}}</div> -->
      <!-- <div>- - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -</div> -->
       <div class="separator"></div>
      <p>&nbsp;</p>
    </div>
  </div>
</template>
<!--
<div class="text-right">{{row.mainstorage.name}} {{row.localcollnumber}}</div><br>


-->

<script>
import PointWidget from '@/components/widgets/PointWidget.vue';
import DateWidget from '@/components/widgets/DateWidget.vue';
import TextWidget from '@/components/widgets/TextWidget.vue';
export default {
  name: 'kpabg-moss-print-page',
  components: {
    PointWidget,
    DateWidget,
    TextWidget,

  },
  props:['meta', 'rows'],
  data(){ 
    return {

    }
  },
  methods: {

  },

}
</script>

<style scoped>
@media print {
  .two {
    /* column-count: 2; */
    /* gap: 1.5cm; */
    /* column-rule: 1px dotted #848484; */
    font-family:'Times New Roman';
    font-size: 13px;
    line-height: 1.3;
    size: landscape;
    margin: 0cm 4cm 0cm 0.5cm; /* Верх, Право, Низ, Лево */
    /* border-right: 1px dotted #848484; */

  column-width: 48%;

	column-count: 2;

	column-gap: 4%;



  /* border-left: 4px dotted #840484; */
    
  }

  /* .one {
    column-count: 1;
    -webkit-column-count: 1;
    -moz-column-count: 1;
    font-family:'Times New Roman';
    font-size: 13px;
    width: 12cm;
    line-height: 1.3;
  } */
/* @page {
  /*margin: 14cm; Верх, Право, Низ, Лево */
/*} */
  .labelbody {
    page-break-inside: avoid;
    /* width: 10cm; */
    /* border-right: 1cm #ffffff;  */
    /* border-right: 1px dotted #848484; */

    /* margin-left: 1em;
    margin-right: 1em; */
/* padding-left: 10px; */
padding-right: 10px;

    /* border-left: 4px dotted #840484; */
    border-right: 1px dotted #848484;
  }

  .separator {
    border-bottom: 1px dotted #848484; /* Точечная линия черного цвета */
    margin: 10px 0; /* Отступ над и под разделителем */
    /* Можно настроить толщину, используя 'border-bottom: 2px dotted #000;' */
  }
}
</style>